function o(n) {
  return "options" in n;
}
export {
  o as isOptionsGroup
};
